<template>
    <div class="row no-gutters body">
        <div class="col-lg-3 middle-background d-none d-lg-block"></div>
        <div class="col-md-12 col-lg-9 middle-background pb-4">
            <div class="row no-gutters">
                <br />
            </div>
            <div class="row no-gutters mt-5 main-card" v-if="!currentUserProfileId && currentUserProfileId === undefined">
                <div class="col-lg-8 pb-3">
                    <div class="row no-gutters">
                        <br />
                    </div>
                    <div class="ml-3 mr-3 mt-lg-2">
                        <no-profile-id-component></no-profile-id-component>
                    </div>
                </div>
            </div>
            <div class=" no-gutters mt-5 main-card" v-else >
                <div class="col-lg-12"> 
                    <div class="row no-gutters">
                        <br />
                    </div>
                    <nav class="nav card-header1 d-flex justify-content-between p-1 ml-3 mr-3 mt-2 mb-3" id="nav">
                        <div class="d-flex col-12 p-0">
                            <div class=" input-group search-input p-0 mr-2 "  >
                                <div class="input-group-prepend " >
                                    <span class="input-group-text img-input-group" id="basic-text">
                                        <img :src="searchimg" class="imgborder" alt="search"/> 
                                    </span>
                                </div>
                                <input
                                class="form-control input-border"
                                type="text"  @focus="enableSearchImg" @blur="disableSearchImg" @keyup="checkForReset"
                                placeholder="Designation"  id="searchedInput" autocomplete="off"
                                aria-label="Search"  v-model="jobText"    
                                />
                            </div>
                            <div class="input-group search-input p-0 mr-2" >
                                <div class="input-group-prepend " >
                                    <span class="input-group-text img-input-group" id="basic-text">
                                        <img :src="locationimg" class="imgborder" alt="search"/> 
                                    </span>
                                </div>
                                <input
                                class="form-control input-border"
                                type="text"  @focus="enableLocationImg" @blur="disableLocationImg" @keyup="checkForReset"
                                placeholder="Location"  id="searchedInput" autocomplete="off"
                                aria-label="Search"  v-model="locationSearchtext"    
                                />
                            </div>
                            <div class="d-flex justify-content-end " v-if="jobText.length ===0 && locationSearchtext.length ===0">
                                <div class="">
                                    <a  class="btn button-create btn-color borderradius20 mouseoverbtn2"  id="search">
                                        <span class="proximanova-semibold fontsize16 black60">Search</span>
                                    </a>
                                </div>
                            </div>
                            <div class="d-flex justify-content-end " v-if="(jobText.length > 0 || locationSearchtext.length > 0)">
                                <div @click="applyFiltersForJobs">
                                    <a  class="btn button-create btn-color find-button borderradius20 mouseoverbtn2"  id="search">
                                        <span class="fontsize16 white proximanova-semibold">Find</span>
                                    </a>
                                </div>
                            </div>
                            <div v-if="(jobText.length > 0 || locationSearchtext.length > 0) && applyFilters" class="d-flex justify-content-end ml-2" @click="resetSearch">
                                <a  class="btn button-create btn-color find-button borderradius20 mouseoverbtn2"  id="search">
                                    <span class="fontsize16 white proximanova-semibold">Clear</span>
                                </a>
                            </div>
                        </div>                        
                        <!-- <div v-if="jobText.length> 0" class="pl-3 pt-3 ">
                            <span class="proximanova fontsize12 black50">Popular searches</span>
                            <div class="d-flex flex-wrap mb-3 ">
                                <div v-for="(job, index) in searchsuggestions" :key="index" class="pr-2">
                                    <div class=" p-1 knowledgeItem d-flex mt-1" @click="AssignJobToValue(job)">
                                        <img :src="suggestionSearchImg" class="imgborder suggestedImg ml-1" alt="search"/> 
                                        <span class="proximanova fontsize12 ml-2 mr-1">{{job }}</span>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                    </nav>
                    <!-- <div class="col-12 d-flex justify-content-between mt-3 mb-3 mr-2 ml-lg-2 mt-lg-4" v-if="jobText.length ===0 ">
                        <div class="fontsize16 proximanova-semibold black ml-3" >
                            <p>Saved Jobs</p>
                        </div>                        
                        <div class="d-flex justify-content-end mr-3"> 
                            <div class="navtoPage mr-2" @click="openDropDown">
                                <img src="../assets/FiltersNew.svg"  class="img-fluid " />
                                <label class="fontsize14 proximanova-semibold black ml-2" >Filters</label>
                                        
                            </div>
                            <div class="filtermenu dropdown-menu"  v-if="showdropdown" id = "filterDropdown" >
                                <div class="p-2">
                                    <div  class="fontsize12 proximanova-bold black d-flex justify-content-between col-12 mb-2 ml-2 mt-1">
                                        <span>Filters </span>
                                        <div class="closebtnmouseover">
                                            <img src="../assets/Close.svg" class="img-fluid closebtn float-right" @click="closeDropDown">
                                        </div>
                                    </div>
                                    <div class="line1"></div>
                                    <div class="d-flex input-group col-12 mt-2 mb-2">
                                        <input
                                        class="form-control proximanova-semibold fontsize12 black60 "
                                        type="text"            
                                        placeholder="Search Location" id="locationtext" autocomplete="off"
                                        aria-label="Search"  @input ="searchlocation" v-model="locationText"  
                                        />
                                        <div class="input-group-append">
                                            <span class="input-group-append img-input-group" >
                                            <img src="../assets/Search.svg" class="imgborder-search"/>
                                            </span>
                                        </div>
                                        <div class="dropdown-menu col-10 ml-3 d-flex"  v-if="showLocationDropdown && locationText.length> 0"    > 
                                            <div class="fontsize12 black60 proximanova  ml-3 hover">
                                                <li class="list-group-item" v-for="(item,index) in searchedLocations" :key="index" @click="selectLocation(item.cityName)">
                                                    {{item.cityName}}
                                                </li>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class=" col-12 mt-1  font14-opacity60">
                                        <div class="row d-flex justify-content-between ml-2 mb-2 mt-2">
                                            <div  v-if="showNewLocations">
                                                <div class="col-6" v-for="(item,index) in newSelectedLocations" :key="index">
                                                    <input type="checkbox" v-model="selectedlocations" checked class="form-check-input check-with-label"  :id="item" :value="item">
                                                    <label class="fontsize12 black60 proximanova label-for-check " for="index">{{item}}</label>
                                                </div>
                                            </div>
                                            <div class="col-6" v-for="(item,index) in defaultLocations" :key="index">
                                                <input type="checkbox" v-model="selectedlocations" checked="checked" class="form-check-input check-with-label" :id="item" :value="item">
                                                <label class="fontsize12 black60 proximanova label-for-check " for="index">{{item}}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end mr-2" v-if="newSelectedLocations.length> 0">
                                        <a class="fontsize12 black60 proximanova hover" v-if="!showNewLocations" @click="showNewLocations = true">View More</a>
                                        <a class="fontsize12 black60 proximanova hover" v-if="showNewLocations" @click="showNewLocations = false">View Less</a>
                                    </div>
                                    <div class="col-12">
                                        <div class="horizonline1"></div> 
                                    </div>
                                    <span class="proximanova fontsize12 black60 ml-3" :class="{'text-color' :sortBy.length > 0}">Sort by</span>
                                    <div class=" col-12 mt-1  font14-opacity60">
                                        <div class="row d-flex justify-content-between ml-2 mb-2 mt-2">
                                            <div class="col-6" v-for="(item,index) in defaultSortBy" :key="index">
                                                <input type="checkbox" v-model="sortBy" checked="checked" class="form-check-input check-with-label"  :id="item" :value="item">
                                                <label class="fontsize12 black60 proximanova label-for-check " for="index">{{item}}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="horizonline1"></div> 
                                    </div>
                                    <div class="d-flex justify-content-end  pr-3 pt-3 pb-2">
                                        <a  class="btn button-create btn-color mr-2 " @click="reset" id="search">
                                            <span class="proximanova-semibold fontsize16 black80">Reset</span>
                                        </a>
                                        <a  v-on:click="search"  class="btn button-create sign-in-button" :disabled="basicinfo" id="search">
                                            <span class="fontsize16 white proximanova-semibold">Show Results</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div  v-if="jobText.length ===0 "> 
                        <div v-for="(job, index) in jobsList" :key="index">
                            <div class="shadow card mr-3 ml-3 mb-3" v-if="index < 2">
                                <div class="p-2 d-flex">      
                                    <div class="col-2">
                                        <div class="backgroundcolor1 p-lg-2 borderradius10 mr-2 mt-4 text-center">
                                            <img src="../assets/Profile_placehlder.svg" class="img-fluid rounded-circle" alt="">
                                        </div>
                                    </div> 
                                    <div class="col-10 pl-0 pt-3">
                                        <div class="d-flex justify-content-between">
                                            <div>
                                                <span class="fontsize24 black proximanova-bold mt-lg-2 pointer" @click="viewJobDetails(job)">{{job.jobTitle}}</span>   <span class="badge badge-secondary ml-2 ml-lg-3 active-badge">Active</span>                                         
                                            </div>
                                            <div>
                                                <img src="../assets/horizontal_menu_icon.svg" width="20px" class="img-fluid mr-2 pointer more_optionhoriz" alt="">
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column mt-1">
                                            <span class="fontsize16 black proximanova">{{job.companyName}}</span>
                                            <div>
                                                <span class="fontsize14 black60 proximanova">{{job.type}}</span>
                                                <span class="ml-2 mr-2 black60">|</span>
                                                <span class="fontsize14 black60 proximanova">{{job.country}}</span>
                                            </div>
                                        </div>
                                        <div class="d-flex mt-2 justify-content-between">
                                            <div class="mt-1">
                                                <span class="proximanova-semibold fontsize14 black">1d ago</span>
                                                <span class="proximanova fontsize12 black60 mt-1"> - Hiring with in 7 days</span>
                                                                    <span class="verticaline ml-2 mr-2"> | </span> 
                                                                    <span class="proximanova fontsize10 black60 pl-1"> 39 Applications </span> 
                                            </div>
                                        </div>
                                        
                                        <div class="d-flex   justify-content-between">
                                            <div class="d-flex flex-column  mb-2 pt-2 justify-content-between">
                                                <div class="row mt-2 ml-0 d-flex "  >
                                                    <div  v-for="(item1,index1) in followersProfilePictures" :key="index1" class="d-flex">
                                                        <div  class="">                                                        
                                                            <img :src="item1" class="img-fluid rounded-circle" id="followImage">                                                                        
                                                        </div>                                          
                                                    </div> 
                                                    <span class="proximanova fontsize10 black60 ml-1 mt-2">5+ followers works here</span>                                                           
                                                </div> 
                                            </div>
                                            <div class="d-flex justify-content-end  pt-3 pb-2 my-auto">
                                                <a  class="btn button-create btn-color mr-2 btnsmall"  id="search">
                                                    <span class="proximanova-semibold fontsize16 black80">Save</span>
                                                </a>
                                                <a  class="btn backgroundcolor3" @click="ApplyJob(job)">
                                                    <span class="fontsize16 white proximanova-semibold">Apply</span>
                                                </a>
                                            </div>
                                            
                                        </div>
                                        
                                    </div>                         
                                    
                                </div>
                            </div>
                            <div v-if="index  > 1">
                                <div class=" text-center fontsize12 black60 proximanova-semibold mb-3">View More</div>
                                <hr class="profhoriz ml-3 mr-3">
                            </div>
                        </div>
                    </div> -->
                    <div class="col-11 d-flex justify-content-between mt-3 mr-2 mb-3 ml-lg-2 mt-lg-4">
                        <div class="proximanova-semibold fontsize16 black80 ml-3" >
                            <p>Suggested Jobs</p>
                        </div>
                    </div> 
                    <!-- <div v-if="jobText.length ===0"> -->
                    <div>
                        <div class="col-12 pb-5 mb-4" v-if="suggestedjobsLoader">
                            <img src="../assets/pageloader.svg" class="pageloader" alt="loading">
                        </div>
                        <div v-else >
                            <div v-if="suggestedJobsList.length > 0" class="d-flex">
                            <div class="col-lg-5 pr-lg-0 col-md-12 pb-5 jobslistverticalscroll" id="jobslistdiv" @scroll="handleScroll">
                            <div v-for="(job, index) in suggestedJobsList" :key="index" >
                                <div class="shadow card mr-md-3 ml-md-3 mb-3 pb-2" :class="{'borderleftblue' :selectedJobIndex===index}">
                                    <div class="p-2 d-flex">      
                                        <div class="">
                                            <div class="backgroundcolor1 p-lg-1 borderradius10 mr-2 mt-2 text-center">
                                                <img v-if="job.companyProfileLink" :src="job.companyProfileLink" class="logoimg img-fluid rounded-circle loadingBgImg" alt="profilepic">
                                                <img v-else src="../assets/Profile_placehlder.svg" class="logoimg img-fluid rounded-circle" alt="profilepic">
                                            </div>
                                        </div> 
                                        <div class="col-md-10 col-lg-10 pl-0 pt-2">
                                            <div class="d-flex justify-content-between">
                                                <div>
                                                    <span class="fontsize18 black proximanova-bold mt-lg-2 pointer text-wrap jobName nameBlock" @click="viewJobDetails(index, job)">{{job.jobTitle}}</span>  
                                                     <!-- <span class="badge badge-secondary ml-2 ml-lg-3 active-badge">Active</span>                                          -->
                                                </div>
                                                <div>
                                                    <img src="../assets/horizontal_menu_icon.svg" :id="job.moremenuname" width="22px" height="22px" v-popover = "{name: job.moremenuname}" class="img-fluid mr-2 pointer closebtnmouseover more_optionhoriz" alt="moremenu">
                                                    <popover :name="job.moremenuname" class="welcomemenu">
                                                        <div class="p-2">
                                                            <div class="d-flex p-1 justify-content-between">
                                                            <span class="fontsize12 proximanova-bold black">More Actions</span>
                                                            <div class="">
                                                                <img src="../assets/Close1.svg" alt="close" class="img-fluid pointer closebtnmouseover" height="17px" width="17px" @click="closeMoreActions(job.moremenuname)">
                                                            </div>
                                                            </div>
                                                            <div class="d-flex p-1 action pointer" id="onclickshare" @click="getReportmessage(job, index)">
                                                                <img src="../assets/Hide.svg" alt="hide" class="img-fluid pl-1 pr-1 ">
                                                                <span class="pt-1 pl-2 d-flex flex-column">
                                                                <div class="fontsize14 black80 proximanova">Report Job</div>
                                                                </span>
                                                            </div>
                                                            <div class="d-flex p-1 action pointer" @click="openHideConfirmationmodal(job)">
                                                                <img src="../assets/Report.svg" alt="report" class="img-fluid pl-1 pr-1">
                                                                <span class="pt-1 pl-2 d-flex flex-column">
                                                                <div class="fontsize14 black80 proximanova">Hide Job</div>
                                                                </span>
                                                            </div>
                                                            <div class="d-flex p-1 action pointer d-block d-lg-none"  @click="shareJob(job)">
                                                                <img src="../assets/sharejob.png" alt="report" width="28" height="20" class="my-auto pl-1 pr-1">
                                                                <span class="pt-1 pl-2 d-flex flex-column">
                                                                    <div class="fontsize14 black80 proximanova">Share</div>
                                                                </span>
                                                            </div>
                                                            <div class="d-flex p-1 action pointer d-block d-lg-none" @click="copyJobLink(job)">
                                                                <img src="../assets/hyperlink1.png" alt="report" width="28" height="20" class="my-auto pl-1 pr-1">
                                                                <span class="pt-1 pl-2 d-flex flex-column">
                                                                <div class="fontsize14 black80 proximanova">Copy link</div>
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </popover>
                                                </div>
                                            </div>
                                            <div class="d-flex flex-column">
                                                <span class="fontsize14 black proximanova">{{job.companyName}}</span>
                                                <div>
                                                    <span class="fontsize14 black60 proximanova">{{job.industry}}</span>
                                                    <span class="ml-2 mr-2 black60" v-if="job.country">|</span>
                                                    <span class="fontsize14 black60 proximanova" v-if="job.country">{{job.country}}</span>
                                                </div>
                                            </div>
                                            <div class="d-md-flex flex-lg-column ">
                                                <div class="">
                                                    <span class="fontsize14 black  proximanova-semibold" v-if="job.creationD">{{job.creationD | moment("from", "now", true)}} ago</span>
                                                    <span class="fontsize12 black60 proximanova mt-1"> - Hiring with in 7 days</span>
                                                </div>
                                                <div class="d-flex ">
                                                    <span class="verticaline ml-2 mr-2 d-none d-md-block d-lg-none"> | </span> 
                                                    <span class="proximanova fontsize10 black60 pl-1 pl-lg-0 mt-2"> {{job.jobApplicantCount}} Applications </span> 
                                                </div>
                                            </div>
                                            <div class="pt-2 mt-1 d-flex d-lg-none">
                                                <!-- <div class="my-auto">
                                                    <button class="btn button-cancel11 mr-2 navtoPage proximanova mouseoverbtn1">Save</button>
                                                </div> -->
                                                <div class="my-auto">
                                                <button v-if="!job.applied" class="btn backgroundcolor3 borderradius20 white fontsm proximanova mouseoverbtn2" :disabled="applyBtnClicked" @click="ApplyJob(job)">Apply</button>
                                                <span v-else class="fontsize14 green proximanova">Applied</span>
                                                </div>
                                            </div>
                                            <!-- <div class="d-flex   justify-content-between">
                                                <div class="d-flex flex-column  mb-2 pt-2 justify-content-between">
                                                    <div class="row mt-2 ml-0 d-flex "  >
                                                        <div  v-for="(item1,index1) in followersProfilePictures" :key="index1" class="d-flex">
                                                            <div  class="">                                                        
                                                                <img :src="item1" class="img-fluid rounded-circle" id="followImage">                                                                        
                                                            </div>                                          
                                                        </div> 
                                                        <span class="proximanova fontsize10 black60 ml-1 mt-2">5+ followers works here</span>                                                           
                                                    </div> 
                                                </div>
                                                <div class="d-flex justify-content-end  pt-3 pb-2 my-auto">
                                                    <a  class="btn button-create btn-color mr-2 btnsmall"  id="search">
                                                        <span class="proximanova-semibold fontsize16 black80">Save</span>
                                                    </a>
                                                    <a class="btn backgroundcolor3" @click="ApplyJob(job)" v-if="!job.applied">
                                                        <span class="fontsize16 white proximanova-semibold">Apply</span>
                                                    </a>
                                                    <a class="my-auto"  v-if="job.applied">
                                                        <span class="fontsize16 green proximanova-semibold">Applied</span>
                                                    </a>
                                                </div>
                                            </div> -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 pb-5 mb-4" v-if="suggestedjobsloadmoreLoader">
                                <img src="../assets/pageloader.svg" class="pageloader" alt="loading">
                            </div>
                            </div>
                            <div class="col-lg-7 col-md-12 pl-0 d-none d-md-none d-lg-block jobslistverticalscroll">
                                <selecetd-job-deatils></selecetd-job-deatils>
                            </div>
                            </div>
                            <div v-else>
                                <div class="ml-3 mr-3">
                                    <no-records-found :message="noRecordsFoundMessage"></no-records-found>
                                </div>
                            </div>
                        </div>
                        <!-- <div>
                            <div class=" text-center fontsize12 black60 proximanova-semibold mb-3">View More</div>
                            <hr class="profhoriz ml-3 mr-3">
                        </div> -->
                    </div>
                    <!-- <div class="col-12 d-flex justify-content-between mt-3 mr-2 mb-3 ml-lg-2 mt-lg-4" v-if="jobText.length > 0 ">
                        <div class="proximanova-semibold fontsize16 black80 ml-3" >
                            <p>Search results </p>
                        </div>                        
                        <div class="d-flex justify-content-end mr-3"> 
                            <div class="navtoPage mr-2" @click="openDropDown">
                                <img src="../assets/FiltersNew.svg"  class="img-fluid " />  
                                <label class="proximanova-semibold fontsize16 black80 ml-2" >Filters</label>
                                    
                            </div>
                            <div class="filtermenu dropdown-menu"  v-if="showdropdown" id = "filterSuggestedDropdown" >
                                <div class="p-2">
                                    <div  class="proximanova-semibold fontsize12 black d-flex justify-content-between col-12 mb-2 ml-2 mt-1">
                                        <span>Filters </span>
                                        <div class="closebtnmouseover">
                                            <img src="../assets/Close.svg" class="img-fluid closebtn float-right" @click="closeDropDown">
                                        </div>
                                    </div>
                                    <div class="line1"></div>
                                    <div class="d-flex input-group col-12 mt-2 mb-2">
                                        <input
                                        class="form-control fontsize12 black60 proximanova "
                                        type="text"            
                                        placeholder="Search Location" id="locationtext" autocomplete="off"
                                        aria-label="Search"  @input ="searchlocation" v-model="locationText"  
                                        />
                                        <div class="input-group-append">
                                            <span class="input-group-append img-input-group" >
                                            <img src="../assets/Search.svg" class="imgborder-search"/>
                                            </span>
                                        </div>
                                        <div class="dropdown-menu col-10 ml-3 d-flex"  v-if="showLocationDropdown && locationText.length> 0"    > 
                                            <div class="fontsize12 black60 proximanova  ml-3 hover">
                                                <li class="list-group-item" v-for="(item,index) in searchedLocations" :key="index" @click="selectLocation(item.cityName)">
                                                    {{item.cityName}}
                                                </li>
                                            </div>
                                        </div> 
                                    </div>
                                    <div class=" col-12 mt-1  font14-opacity60">
                                        <div class="row d-flex justify-content-between ml-2 mb-2 mt-2">
                                            <div  v-if="showNewLocations">
                                                <div class="col-6" v-for="(item,index) in newSelectedLocations" :key="index">
                                                    <input type="checkbox" v-model="selectedlocations" checked class="form-check-input check-with-label"  :id="item" :value="item">
                                                    <label class="fontsize12 black60 proximanova label-for-check " for="index">{{item}}</label>
                                                </div>
                                            </div>
                                            <div class="col-6" v-for="(item,index) in defaultLocations" :key="index">
                                                <input type="checkbox" v-model="selectedlocations" checked="checked" class="form-check-input check-with-label" :id="item" :value="item">
                                                <label class="fontsize12 black60 proximanova label-for-check " for="index">{{item}}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-end mr-2" v-if="newSelectedLocations.length> 0">
                                        <a class="fontsize12 black60 proximanova hover" v-if="!showNewLocations" @click="showNewLocations = true">View More</a>
                                        <a class="fontsize12 black60 proximanova hover" v-if="showNewLocations" @click="showNewLocations = false">View Less</a>
                                    </div>
                                    <div class="col-12">
                                        <div class="horizonline1"></div> 
                                    </div>
                                    <span class="fontsize12 black60 proximanova ml-3" :class="{'text-color' :sortBy.length > 0}">Sort by</span>
                                    <div class=" col-12 mt-1  fontsize14 black60 proximanova">
                                        <div class="row d-flex justify-content-between ml-2 mb-2 mt-2">
                                            <div class="col-6" v-for="(item,index) in defaultSortBy" :key="index">
                                                <input type="checkbox" v-model="sortBy" checked="checked" class="form-check-input check-with-label"  :id="item" :value="item">
                                                <label class="fontsize12 black60 proximanova label-for-check " for="index">{{item}}</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="horizonline1"></div> 
                                    </div>
                                    <div class="d-flex justify-content-end  pr-3 pt-3 pb-2">
                                        <a  class="btn button-create btn-color mr-2 " @click="reset" id="search">
                                            <span class="proximanova-semibold fontsize16 black80">Reset</span>
                                        </a>
                                        <a  v-on:click="search"  class="btn button-create sign-in-button" :disabled="basicinfo" id="search">
                                            <span class="fontsize16 white proximanova-semibold">Show Results</span>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                    <div  v-if="jobText.length > 0 ">
                        <div v-for="(job, index) in searchList" :key="index">
                            <div class="shadow card mr-3 ml-3 mb-3" >
                                <div class="p-2 d-flex">      
                                    <div class="col-2">
                                        <div class="backgroundcolor1 p-lg-2 borderradius10 mr-2 mt-4 text-center">
                                            <img v-if="job.companyProfileLink" :src="job.companyProfileLink" class="img-fluid rounded-circle" alt="">
                                            <img v-else src="../assets/Profile_placehlder.svg" class="img-fluid rounded-circle" alt="">
                                        </div>
                                    </div> 
                                    <div class="col-10 pl-0 pt-3">
                                        <div class="d-flex justify-content-between">
                                            <div>
                                                <span class="fontsize24 black proximanova-bold mt-lg-2 pointer" @click="viewJobDetails(job)">{{job.jobTitle}}</span>   <span class="badge badge-secondary ml-2 ml-lg-3 active-badge">Active</span>                                         
                                            </div>
                                            <div>
                                            
                                                <img src="../assets/horizontal_menu_icon.svg" width="20px" class="img-fluid mr-2 pointer more_optionhoriz" alt="">
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column mt-1">
                                            <span class="fontsize16 black proximanova">{{job.companyName}}</span>
                                            <div>
                                                <span class="fontsize14 black60 proximanova">{{job.industry}}</span>
                                                <span class="ml-2 mr-2 black60" v-if="job.country">|</span>
                                                <span class="fontsize14 black60 proximanova" v-if="job.country">{{job.country}}</span>
                                            </div>
                                        </div>
                                        <div class="d-flex mt-2 justify-content-between">
                                            <div class="mt-1">
                                                <span class="fontsize14 black  proximanova-semibold" v-if="job.creationD">{{job.creationD | moment("from", "now", true)}} ago</span>
                                                <span class="fontsize12 black60 proximanova mt-1"> - Hiring with in 7 days</span>
                                                <span class="verticaline ml-2 mr-2"> | </span> 
                                                <span class="proximanova fontsize10 black60 pl-1"> {{job.jobApplicantCount}} Applications </span> 
                                            </div>
                                        </div>
                                        
                                        <div class="d-flex   justify-content-between">
                                            <div class="d-flex flex-column  mb-2 pt-2 justify-content-between">
                                                <div class="row mt-2 ml-0 d-flex "  >
                                                    <div  v-for="(item1,index1) in followersProfilePictures" :key="index1" class="d-flex">
                                                        <div  class="">                                                        
                                                            <img :src="item1" class="img-fluid rounded-circle" id="followImage">                                                                        
                                                        </div>                                          
                                                    </div> 
                                                    <span class="proximanova fontsize10 black60 ml-1 mt-2">5+ followers works here</span>                                                           
                                                </div> 
                                            </div>
                                            <div class="d-flex justify-content-end  pt-3 pb-2 my-auto">
                                                <a class="btn button-create btn-color mr-2 btnsmall"  id="search">
                                                    <span class="proximanova-semibold fontsize16 black80">Save</span>
                                                </a>
                                                <a class="btn backgroundcolor3" @click="ApplyJob(job)" v-if="!job.applied">
                                                    <span class="fontsize16 white proximanova-semibold">Apply</span>
                                                </a>
                                                <a class=""  v-if="job.applied">
                                                    <span class="fontsize16 green proximanova-semibold">Applied</span>
                                                </a>
                                            </div>
                                            
                                        </div>
                                        
                                    </div>                         
                                    
                                </div>
                            </div>
                        </div>
                    </div> -->
                </div>
            </div>
        </div>
        <reportMessageModal  v-if="reportmodalopen" :reportmessage="reportmessagesobject" @closereport = "closereportModal"></reportMessageModal>
        <hide-confirmation-modal  :modalTitle="modalTitle" v-if="hideconfirmationmodalopen" @closeConfirmModal = "CloseHideConfirmationModal"></hide-confirmation-modal>
        <APIerrorModal v-if="displayAPIerrorModal" @closeAPIerrorModal="closeAPIerrorModal"></APIerrorModal>
        <MeetYourProfileStrengthModal v-if="openMeetYourProfileStrengthModal" @closeMeetYourProfileStrengthModal="closeMeetYourProfileStrengthModal"></MeetYourProfileStrengthModal>
    </div>
</template>
<script>
import { bus } from "../main";
import pendingActivities from "../components/PendingActivities.vue";
import httpuserprofile from "@/js/http-userprofile.js";
import router from '../router.js'
import reportMessageModal from '@/components/ReportJobModal.vue';
import SelecetdJobDeatils from '../components/SelectedJobDetails.vue'
import NoProfileIdComponent from '../components/NoProfileId.vue'
import HideConfirmationModal from '../components/ConfirmationModal.vue'
import NoRecordsFound from '../components/NoRecordsFound.vue'
import APIerrorModal from '../components/APIerrorpopup.vue'
import MeetYourProfileStrengthModal from '../components/MeetYourProfileStrength.vue'
import commonUtils from '@/js/common-utils.js'
import sessionUtils from '@/js/session-util.js'
export default{
    components: {
        pendingActivities,
        reportMessageModal,
        SelecetdJobDeatils,
        NoProfileIdComponent,
        NoRecordsFound,
        HideConfirmationModal,
        MeetYourProfileStrengthModal,
        APIerrorModal
    },
data(){
    return{
        activeClass: 'Track',
        applyBtnClicked : false,
        noRecordsFoundMessage : 'No records found',
        modalTitle : "Are you sure you want to hide this job ?",
        currentUserProfileId: null,
        currentUserEmail : null,
        apllyFilters: false,
        showSuggested: false,
        showTracking :true,
        resultCount: 3,
        showdropdown: false,
        showSuggesteddropdown: false,
        jobText: '',
        locationSearchtext: '',
        locationText: '',
        searchedLocations : [],
        showLocationDropdown: false,
        newSelectedLocations: [],
        selectedlocations: [],
        sortBy: [],     
        basicinfo: false,   
        showNewLocations:false,
        applyFilters: false,
        isScrolled : false,
        filterResult : false,
        limit : 10,
        offset : 0,
        displayAPIerrorModal : false,
        openMeetYourProfileStrengthModal : false,
        reportmodalopen : false,
        reportedVideoIndex : null,
        hideconfirmationmodalopen : false,
        selectedJobForHide : null,  
        suggestedjobsLoader : true,
        suggestedjobsloadmoreLoader : false,
        searchList : [
              {companyName : 'WorkNotion', type:'Professional Network services', country : 'USA', jobTitle : 'Product Designer', jobStatus:'active'},
              {companyName : 'WorkNotion', type:'Professional Network services', country : 'USA', jobTitle : 'Frontend Developer', jobStatus:'inactive'},
              {companyName : 'WorkNotion', type:'Professional Network services', country : 'USA', jobTitle : 'Java Developer', jobStatus:'inactive'}
        ],
        jobsList : [
              {companyName : 'WorkNotion', type:'Professional Network services', country : 'USA', jobTitle : 'Product Designer', jobStatus:'active'},
              {companyName : 'WorkNotion', type:'Professional Network services', country : 'USA', jobTitle : 'Frontend Developer', jobStatus:'inactive'},
              {companyName : 'WorkNotion', type:'Professional Network services', country : 'USA', jobTitle : 'Java Developer', jobStatus:'inactive'}
        ],
        selectedJobIndex : null,
        instanceSuggestedJobsList : [],
        suggestedJobsList : [],
        searchimg: require('../assets/Designation.svg'),
        suggestionSearchImg: require('../assets/Designation.svg'),
        locationimg: require('../assets/Location.svg'),
        searchText: '',
        defaultLocations : ['Hyderabad','Bangalore','Delhi','Pune'],
        defaultSortBy: ['Review','Assessment','Shortlisted','Interview','Selected','Hired','Disqualified'],
        followersProfilePictures: [require('../assets/Group2.svg'),require('../assets/Group2.svg'),require('../assets/Group2.svg'),require('../assets/Group2.svg')],
        searchsuggestions: ['Produce Designer','UX Designer','UI Designer','Graphic Designer','Visual Designer']
    }
},
methods:{
    closeAPIerrorModal(){
        this.displayAPIerrorModal = false;
    },
    closeMeetYourProfileStrengthModal() {
        this.openMeetYourProfileStrengthModal = false;
    },
    // this will invoke after click on job title on search suggestions
    AssignJobToValue(job) {
        this.jobText = job;
    },
    copyJobLink(jobObj) {
        commonUtils.copyJobLink(jobObj)
    },
    shareJob : function(jobObj){
      commonUtils.shareJob(jobObj)
    },
    //not in used
    toggleActiveClass(elementId) {        
        this.activeClass = elementId;
        if (elementId == "suggested") {
            this.showSuggested = true;
            this.showTracking = false
            this.suggested();
        }else if (elementId == "Saved") {
            this.showSuggested = false;
            this.showTracking = false
        }else if (elementId == "Posted") {
            this.showSuggested = false;  
            this.showTracking = false      
        }else {
            this.showSuggested = false;
            this.showTracking = true
        }
    }, 
    // getting suggested jobs list
    getSuggestedJobsList(){
        this.filterResult = false;
        httpuserprofile.get('/userprofile/getSuggestedJobsOnDesignation?profileId='+this.currentUserProfileId+'&limit='+this.limit+'&offset='+this.offset)
        .then(response => {
            this.suggestedjobsLoader = false;
            this.suggestedjobsloadmoreLoader = false;
            this.isScrolled = false;
            console.log("suggested jobs : ", response) 
            this.instanceSuggestedJobsList = response.data
            for(var i =0; i < this.instanceSuggestedJobsList.length; i++){
                this.instanceSuggestedJobsList[i].moremenuname = 'sugJob'+this.instanceSuggestedJobsList[i].jobId
                this.suggestedJobsList.push(this.instanceSuggestedJobsList[i])
            }
            if(this.suggestedJobsList.length > 0 && this.offset === 0){
                this.displayDefaultJobInfo()
            }      
        }).catch(error=>{   
            this.suggestedjobsLoader = false;
            this.suggestedjobsloadmoreLoader = false;
            console.log(error);  
        })   
    },
    // this will invoke after getting the initial set of results
        // select first job as a selected job and display the selecetd job information
    displayDefaultJobInfo(){
        var jobs = document.getElementsByClassName('jobName')
        console.log(jobs)
        if(screen.width > 900) {
            setTimeout(function() {
                jobs[0].click()
            },2000);
        }
    },
    // this will invoke after click on job title to display selected job information
    // for large devices sending the required information through bus event
    // for small & medium devices navigate to another page (job_details) to display selected job infromation
    viewJobDetails(index, job){
        this.selectedJobIndex = index;
        this.$session.set("selectedJobId", job.jobId);
        this.$session.set("selectedJobApplyStatus", job.applied)
        let jobObj = {
            jobId : job.jobId,
            applyStatus : job.applied
        }
        // bus.$emit('jobSelection', job.jobId)
        bus.$emit('jobSelection', jobObj)
        if(screen.width < 900) {
            router.push({
                name : 'job_details'
            })
        }
    },
    // this will invoke after click on close button on moremenu card
    closeMoreActions(id){
        document.getElementById(id).click()
    },
    // this will invoke after click on hide option in moremenu options of individual job
    // hide the job to the particular user
    hideAJob(job){
        var vm = this;
        httpuserprofile.post('/userprofile/hideAJob?profileId='+this.currentUserProfileId+'&jobId='+job.jobId)
        .then((response) =>{
            console.log("hide job : ", response)
            vm.$toast.success("Successfully hide a job")
            this.selectedJobForHide = null;
            this.suggestedjobsLoader = true;
            this.instanceSuggestedJobsList = [];
            this.suggestedJobsList = [];
            this.offset = 0;
            this.getSuggestedJobsList()
        }).catch((e) => {
            console.log(e.response)
            this.displayAPIerrorModal = true;
        })
    },
    openHideConfirmationmodal(job){
        this.hideconfirmationmodalopen = true;
        this.selectedJobForHide = job;
    },
    CloseHideConfirmationModal(hidestatus){
        if(hidestatus == 'SUCCESS'){
            console.log("api call to hide job", this.selectedJobForHide)
            this.hideconfirmationmodalopen = false;
            this.hideAJob(this.selectedJobForHide)
        }else{
            console.log("cancel hide")
            this.hideconfirmationmodalopen = false;
            this.selectedJobForHide = null;
        }
    },
    // this will invoke after click on report option in moremenu options of individual job
    // report the particular job 
    // a report modal component will display after click on report button 
    // and passing the job item as a props to the modal to report the job
    getReportmessage(item,index){
       this.reportedVideoIndex = index
       console.log('enter here reportindex : ', index)
       this.reportmodalopen = true;         
        item.currentuserId = this.currentUserProfileId;
        this.reportmessagesobject = item;  
        this.closeMoreActions(item.moremenuname)
    }, 
    // this will invoke after click on close button on report modal / after successfully reported on a video
    // if job reported successfully reset the data 
    closereportModal(type){
        var vm = this;
      this.reportmodalopen = false;
      if(type === 'SUCCESS') {
        console.log("reported job")
        vm.$toast.success("Successfully reported on a job")
        // this.suggestedJobsList.splice(this.reportedVideoIndex,1);
        // this.suggestedJobsList.forEach((job,index) =>{
        //     job.moremenuname = 'sugJob'+job.jobId;
        // })
        // var reportindex = this.reportedVideoIndex
        // console.log(this.suggestedJobsList)
        // // if(this.reportedVideoIndex == 0){
        // //     this.displayDefaultJobInfo()
        // // }
        // if((this.selectedJobIndex == this.reportedVideoIndex) || (this.reportedVideoIndex = 0)){
        //     console.log("inside loader", this.reportedVideoIndex , this.selectedJobIndex)
        //     setTimeout(function() {
        //         var jobs = document.getElementsByClassName('jobName')
        //         jobs[reportindex].click()
        //     }, 1500); 
        // }
        this.suggestedjobsLoader = true;
        this.instanceSuggestedJobsList = [];
        this.suggestedJobsList = [];
        this.offset = 0;
        this.getSuggestedJobsList()
      }else{
        console.log("notsuccess ", type)
      }
         
    },
    // this will invoke after click on apply job button in indivual job card
        // after successfully applied if job has any screening questions navigate user to record screening questions page to record
    ApplyJob(jobItem) {
        let canbeApply = commonUtils.checkJobLevelToApply(jobItem.seniority)
        if(canbeApply){
        console.log("selected job item : ", jobItem)
        var vm = this;
        this.$session.set("selectedJobId", jobItem.jobId);
        if(jobItem.screeningQuestions && jobItem.screeningQuestions.length > 0){
            this.MoveToRecordScreeningQuestions()
        }else{
        this.applyBtnClicked = true;
        let obj = {
            jobId: jobItem.jobId,
            userProfileId: this.currentUserProfileId,
            jobStatus: "POST",
            creationD: null,
            creationUserI: this.currentUserEmail,
            updateD: null,
            updatedUserI:null  
        }
        console.log(obj)
        httpuserprofile.post('/userprofile/ApplyToJob', obj)
        .then(response => {    
            console.log("apply for a job : ", response)
            if(response.data.errorCode !== 1047) {
                this.$session.set("selectedJobId", jobItem.jobId);
                this.applyBtnClicked = false;
                jobItem.appliedStatus = 'Y';
                vm.$toast.success("Applied successfully")
                // if(jobItem.screeningQuestions && jobItem.screeningQuestions.length > 0){
                //     this.MoveToRecordScreeningQuestions()
                // }
            }
        }).catch(error=>{   
            console.log(error);  
            this.applyBtnClicked = false;
            this.displayAPIerrorModal = true;
        }) 
        }
        }else{
            this.openMeetYourProfileStrengthModal = true;
        }
        // this has  to be called once get successfully applied for the job
        // this.MoveToRecordScreeningQuestions()
    },
    MoveToRecordScreeningQuestions(){
        router.push({
            name : 'recordScreeningQuestions'
        })
    },
    //this will invoke after scrolling down to get more records
    handleScroll () {   
        var myDiv = document.getElementById('jobslistdiv')
        if(screen.width > 800) {
        if(!this.isScrolled){        
            // console.log(myDiv.offsetHeight + myDiv.scrollTop)
            // console.log(myDiv.scrollHeight)
            // if (((window.innerHeight + window.scrollY +1) >= document.body.offsetHeight) && !this.showdropdown) { 
            if (myDiv.offsetHeight + myDiv.scrollTop + 1 >= myDiv.scrollHeight) {
                if(this.instanceSuggestedJobsList.length >= 9){
                    this.isScrolled = true;    
                    this.offset = this.offset+10; 
                    this.suggestedjobsloadmoreLoader = true;
                    if(this.applyFilters) {
                        console.log("into filtered list")
                        this.getFilteredJobsList()
                    }else{
                        console.log("into normal list")
                        this.getSuggestedJobsList();
                    }
                }else{
                    console.log("No more jobs found")
                }                  
            }        
        }    
        }
    },
    //this will invoke after scrolling down to get more records
    handlesmScroll(){
        if(screen.width < 800) {  
        if(!this.isScrolled){               
            if (((window.innerHeight + window.scrollY +1) >= document.body.offsetHeight) && !this.showdropdown) { 
                if(this.instanceSuggestedJobsList.length >= 9){
                    this.isScrolled = true;    
                    this.offset = this.offset+10; 
                    this.suggestedjobsloadmoreLoader = true;
                    if(this.applyFilters) {
                        console.log("into filtered list")
                        this.getFilteredJobsList()
                    }else{
                        console.log("into normal list")
                        this.getSuggestedJobsList();
                    }
                }else{
                    console.log("No more jobs found")
                }             
            }        
        }   
        }
    },
    // this will invoke after click on find button to get filtered jobs list
    getFilteredJobsList() {
        httpuserprofile.get('/userprofile/filteredsuggestedjobsbydesignationandlocation?profileId='+this.currentUserProfileId+'&limit='+this.limit+'&offset='+this.offset+'&cityname='+this.locationSearchtext+'&designation='+this.jobText)
        .then((response) => {
            console.log("filtred jobs list : ", response.data)
            this.suggestedjobsLoader = false;
            this.suggestedjobsloadmoreLoader = false;
            this.isScrolled = false;
            this.instanceSuggestedJobsList = response.data
            for(var i =0; i < this.instanceSuggestedJobsList.length; i++){
                this.instanceSuggestedJobsList[i].moremenuname = 'sugJob'+this.instanceSuggestedJobsList[i].jobId
                this.suggestedJobsList.push(this.instanceSuggestedJobsList[i])
            }
            if(this.suggestedJobsList.length > 0 && this.offset === 0){
                this.displayDefaultJobInfo()
            } 
        }).catch((e) => {
            console.log(e)
            this.suggestedjobsLoader = false;
            this.displayAPIerrorModal = true;
        })
    },
    applyFiltersForJobs(){
        console.log('entr', this.jobText, this.locationSearchtext)
        this.applyFilters = true;
        this.offset = 0;
        this.suggestedjobsLoader = true;
        this.suggestedJobsList = [];
        this.instanceSuggestedJobsList = [];
        this.getFilteredJobsList();
    },
    // this will invoke after click on reset button
    // clear all the selected filter options
    // get suggested jobs
    resetSearch(){
        this.jobText = "";
        this.locationSearchtext = "";
        this.applyFilters = false;
        this.disableSearchImg();
        this.disableLocationImg();
        this.offset = 0;
        this.suggestedjobsLoader = true;
        this.suggestedJobsList = [];
        this.instanceSuggestedJobsList = [];
        this.getSuggestedJobsList()
    },
    enableSearchImg(){
        this.searchimg = require('../assets/DesignationBlue.svg')
    },
    disableSearchImg(){
        if(this.jobText.length === 0){
            this.searchimg = require('../assets/Designation.svg')
        }        
    },
    enableLocationImg(){
        this.locationimg = require('../assets/Locationblue.svg')
    },
    disableLocationImg(){
        if(this.locationSearchtext.length === 0){
            this.locationimg = require('../assets/Location.svg')
        }        
    },
    checkForReset() {
        console.log("checking for reset")
        if(this.jobText.length === 0 && this.applyFilters && this.locationSearchtext.length === 0){
            console.log("reset data")
            this.resetSearch()
        }  
    },
    openDropDown(){
        this.showdropdown = true
    },
    closeDropDown(){
        this.showdropdown = false
    },
    openSuggestedDropDown(){
        this.showSuggesteddropdown = true
    },
    closeSuggestedDropDown(){
        this.showSuggesteddropdown = false
    },
    reset(){
        this.applyFilters = false;
        this.selectedlocations = [];
        this.sortBy = [];
        this.showdropdown = false
    },
    resetLocationSelection(text){
        console.log(text)
        var index = this.selectedlocations.indexOf(text);
        this.selectedlocations.splice(index, 1);       
        if(this.selectedlocations.length ===0 && this.sortBy.length ===0){
            this.applyFilters = false
        }
    },
    resetSortSelection(test){
        var index2 = this.sortBy.indexOf(test);
        
        this.sortBy.splice(index2,1);
        if(this.selectedlocations.length ===0 && this.sortBy.length ===0){
            this.applyFilters = false
        }
    },
    search(){
        console.log(this.selectedlocations[0])
        console.log(this.sortBy)
        this.applyFilters = true;
        this.filterResult = true;
        this.showdropdown = false
    },
    // To search the location name based on text in location field of filters
      searchlocation(){
        if(this.locationText.length < 1  ){ 
            this.searchedLocations  = [];       
            return;
        }   
        var self = this;
        setTimeout(function() {
          // TODO
            httpuserprofile.get('/searchController/searchbyLocation?searchText='+self.locationText+'&stateCode=')
            .then(response => {    
                self.searchedLocations = [];    
                self.searchedLocations = response.data;
                if(self.searchedLocations.length > 0){
                    self.showLocationDropdown  = true;
                }                
            }).catch(error=>{   
            console.log(error);  
            })      
        }, 1500); 
    },
    // To select the required location from dropdown
      selectLocation(name){
      if(!this.newSelectedLocations.includes(name) && !this.defaultLocations.includes(name)){        
        this.selectedlocations = this.selectedlocations.concat(name);     
        this.newSelectedLocations = this.newSelectedLocations.concat(name); 
      }   
        this.searchedLocations = [];
        this.locationText = '';
        this.showLocationDropdown  = false;
    },
},
mounted(){
    this.currentUserProfileId = sessionUtils.getUserProfileId();
    this.currentUserEmail = sessionUtils.getUserEmail();
    if(this.currentUserProfileId){
    this.getSuggestedJobsList()
    }
},
created(){
   window.addEventListener('scroll', this.handlesmScroll);
   bus.$on("refreshDatawhenInSameJobPage", data => {
        if(data){
            this.resetSearch()
        }
    })
},
beforeDestroy(){
    // this.$session.remove("selectedJobId")
    // this.$session.remove("selectedJobApplyStatus")
    bus.$off('refreshDatawhenInSameJobPage')
    window.removeEventListener('scroll', this.handlesmScroll);
}
}
</script>
<style scoped>
.active-badge{
    background: rgba(30,198,160,0.1) !important;
    border-radius: 10px;
    border-color: rgba(16,163,129,0.2) !important;
    border: 1px solid;
    color:#10A381;
    font-size: 12px;
}
#search{
    background-color: white
}
.button-cancel11 {
  border: 1px solid #1f1f1f;
  border-radius: 4px;
  transition : ease-out 0.3s;
  font-size: 12px !important;
	position: relative;
	z-index : 1;
}
#followImage{
  width: 30px;
  height: 30px;
  transform: scale(1.2)  !important;
  border: 1px solid #1F1F1F;
}
.loadingBgImg{
  background: transparent url('../assets/loading_gif1.gif') center no-repeat;
  background-size: 30px 30px;
}
.welcomemenu.vue-popover.dropdown-position-bottom:before{
    display: none;
}
.welcomemenu.dropdown-position-bottom {
  left: unset !important;
  top: 20px !important;
  width: 290px !important;
  padding: 10px 10px 10px 10px !important;
  transform: translate3d(-82%, 10px, 10px) !important;
}
#jobField{
    width:20%;
    min-width: 50%
}
.font16black{
    font-size: 16px;
}
.action:hover{
    background: rgba(31,31,31,.1);
    border-radius: 5px;
}
.input-border{
  border-radius: 0px 10px 10px 0px;
}
.nameBlock:hover{
	color:#007AFF !important;
	text-decoration: underline;
	white-space: nowrap;
	}
.button-cancel1 {
  border: 1px solid #1f1f1f;
  opacity: 0.3;
  border-radius: 4px;
  /* transition: border 8s; */
}
.button-cancel1{
  opacity: 1;
  /* color: yellow; */
  background: -webkit-linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%);
  -webkit-background-clip: text;
-webkit-text-fill-color: transparent;
  border: 2px solid transparent;
  border-radius: 10px !important;
  -moz-border-image: -moz-linear-gradient(top, #E6784F 0%, #EA5184 100%);
  -webkit-border-image: -webkit-linear-gradient(top, #E6784F 0%, #EA5184 100%);
  border-image: linear-gradient(to bottom, #E6784F 0%, #EA5184 100%);
  border-image-slice: 1;
}
.pageloader {
  width: 7%;
  margin-top: 5%;
  margin-bottom: 5%;
  margin-left: 46%;
}
.button-cancel1::after{
    border-radius: 10px !important;
}
#searchedInput{
    background-color: white !important;
}
.imgborder {
  background-color: white;
  border-radius: 10px 0px 0px 10px;
}
#basic-text{
    background-color: white !important;
    border-radius: 10px 0px 0px 10px;
}
.card {
  border: 1px solid #dddfe5;
  border-radius: 10px;
  background-color: #ffffff;
}
.card-header1 {
  border: 1px solid #d9dce1;
  background-color: rgba(161, 166, 179,0.06);
 
  border-radius: 8px;
}   
.main-badge {
    background: linear-gradient(44.51deg, #E6784F 0%, #EA5184 100%) !important;
    font-size: 12px !important;
    /* opacity: 30%; */
}
.input-group-append{
  margin-left: 0 !important;
}
#filterDropdown{
  left : unset !important;
  z-index: 3;
  width: 320px !important;
  cursor: pointer;
}
#filterSuggestedDropdown{
   
     left : unset !important;
  z-index: 3;
  width: 320px !important;
  cursor: pointer;
}
.navtoPage{
    cursor: pointer;
}
.border{
  padding-left: 10px;
}
.dropdown-menu{
  cursor: pointer;
  position: absolute;
  display:block;    
  color: black;
  box-shadow: 0px 8px 16px 0px rgba(0,23,56,0.1);
  border: none;
  margin-top: 0px;   
  border-radius: 10px  !important;
}
.closebtnmouseover {
    border: 1px solid white;
    padding: 2px;
}
.closebtnmouseover:hover {
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 60%;
  border: 1px solid rgba(161, 166, 179,.5);
}
.form-control {
  background-color: rgb(161, 166, 179,0.1) !important;
  border: 0px solid #ced4da !important;
  /* border-radius: 0px 10px 10px 0px !important; */
}
.form-control:focus{
    outline: none !important;
    box-shadow: none !important;   
    border-radius: 10px;
    background-color: rgba(161, 166, 179,0.1);
    border: #DDDFE5;   
}
.imgborder-search {
  padding: 11px 15px 11px 10px;
  background-color: rgba(161, 166, 179,0.1);
  border-radius: 0px 10px 10px 0px;
}
.sign-in-button{
  font-family: "Proxima Nova";
  font-size: 16px;
  font-weight: 600;
  color: #1F1F1F;
  opacity: 30%;
  transition : ease-out 0.3s;
  POSITION : relative;
  z-index : 1
}
.sign-in-button::before {
  transition : 0.5s all ease;
  position : absolute;
  top : 0;
  left : 30%;
  right : 30%;
  bottom : 0;
  opacity : 0;
  content : "";
  background-color :  rgba(255,255,255,.3);
}
.sign-in-button:hover:before {
  transition : 0.5s all ease;
  left : 0;
  right : 0;
  opacity : 1;
  z-index : -1
}
.btn-color{
  border-color: rgba(31, 31, 31,0.1);
}
.card-body{
    padding:0 !important;
}
.card-footer{
    background-color: rgba(161, 166, 179,0.1);
    padding: unset !important;
}
.rejStatus{
     background-color: rgba(161, 166, 179,0.1);
     border-radius: 10px;
}
.statusImg{
    vertical-align: baseline;
}
.jobProfImg{
    width: 56px;
    height: 56px;
}
.activeSub {
  background-color: #d6e9ff;
  border: 1px solid #9ecbff;
  color: #0078ff;
}
.pillbtn {
  cursor: pointer;
  border: 1px solid #dbdbdb;
  border-radius: 16px;
  padding-left: 8px !important;
  padding-right: 9px !important;
}
.logoimg{
    width: 45px;
    height: 45px;
}
.nobtn{
    color: black;
}
#suggestedJobs{
    width: 112px;
    height: 25px;
}
.suggestedImg{
    width: 10px;
   
}
.knowledgeItem {
  font-family: "Proxima Nova";
  background-color: white;
  border-radius: 10px;
  cursor: pointer;
}
.find-button{
    background-color: #007AFF !important;
    color: white !important;
    padding-left: 20px;
    padding-right: 20px;
}
@media only screen and (max-width: 600px){
    .fontsize24{
        font-size: 18px;
    }
    .btnsmall{
        height: 35px;
        padding: .2rem .5rem !important;
    }
    .nameBlock{
        font-size: 18px !important;
	}
    .pageloader {
        width: 20%;
        margin-left: 40%;
    }
}
@media screen and (max-width: 1020px) and (min-width: 767px) {
  .main-card {
    padding-left: 5%;
    padding-right: 5%;
  }
}
@media screen and (min-width: 770px) {
    .jobslistverticalscroll{
        height: 130vh !important;
        overflow: auto;
    }
    .jobslistverticalscroll::-webkit-scrollbar {
        display: none;
    }
}
@media screen and (min-width: 550px) and (max-width : 768px){
    .logoimg {
        height: 43px;
    }
}
@media screen and (max-width : 550px) {
    .logoimg{
        height: 35px;
    }
}
</style>
